import { render, staticRenderFns } from "./MinistryDetail.vue?vue&type=template&id=3db7c351&scoped=true"
import script from "./MinistryDetail.vue?vue&type=script&lang=js"
export * from "./MinistryDetail.vue?vue&type=script&lang=js"
import style0 from "./MinistryDetail.vue?vue&type=style&index=0&id=3db7c351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db7c351",
  null
  
)

export default component.exports